module.exports = __webpack_public_path__ + "img/file-ai.8312669f.svg";